<app-banner></app-banner>
<app-about></app-about>
<app-how-to-buy></app-how-to-buy>
<app-tokenomics></app-tokenomics>
<app-roadmap></app-roadmap>
<app-faq></app-faq>